module.exports = __webpack_public_path__ + "img/check--success.9add8f7f.svg";